import apiClient from 'api/client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const GRADE_ITEM_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TRACEABILITY,
  VERSIONS.V1,
  RESOURCES.GRADE_ITEM,
  false
);

export const gradeItemApi = {
  gradeItemForm: () => apiClient.get(`${GRADE_ITEM_BASE}/form`),

  editGradeItemForm: Id =>
    apiClient.get(`${GRADE_ITEM_BASE}/form?is_edit=true&grade_item_id=${Id}`),

  createGradeItem: combinedData =>
    apiClient.post(`${GRADE_ITEM_BASE}`, combinedData),

  updateGradeItem: (processed_id, combinedData) =>
    apiClient.put(`${GRADE_ITEM_BASE}/${processed_id}`, combinedData),

  updateGradeItemStatus: (processed_id, isActive) =>
    apiClient.post(
      `${GRADE_ITEM_BASE}/status?id=${processed_id}&isActive=${isActive}`
    )
};
